import { useEffect, useRef } from "react";

export const LIST_REFRESH_EVENT = "app:persistent-list-refresh";

export const notifyListRefresh = () => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(LIST_REFRESH_EVENT));
  }
};

/**
 * Refreshes a kept-alive list only when a child page explicitly reports that
 * data changed (save/edit/approve/etc). Plain Back/Cancel emits nothing, so the
 * existing list/search/filter/pagination state is shown immediately with no API reload.
 */
export const useListRefreshListener = (refreshFn) => {
  const refreshRef = useRef(refreshFn);
  refreshRef.current = refreshFn;

  useEffect(() => {
    const handleRefresh = () => refreshRef.current?.();
    window.addEventListener(LIST_REFRESH_EVENT, handleRefresh);
    return () => window.removeEventListener(LIST_REFRESH_EVENT, handleRefresh);
  }, []);
};

export const backToListWithRefresh = (navigate) => {
  notifyListRefresh();
  navigate(-1);
};
